import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./Blog.css";

const Blog = () => {
  const articles = [
    {
      id: 1,
      slug: "seo-local-commerce-proximite",
      title: "SEO Local : Comment apparaître en premier sur Google pour votre commerce",
      excerpt: "Découvrez les techniques essentielles pour dominer les recherches locales et attirer plus de clients dans votre zone.",
      category: "SEO",
      readTime: "8 min",
      date: "15 Déc 2024",
      image: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=600"
    },
    {
      id: 2,
      slug: "automatisation-reservation-en-ligne",
      title: "Automatiser ses réservations : le guide complet pour les commerçants",
      excerpt: "Comment mettre en place un système de réservation en ligne et gagner des heures chaque semaine.",
      category: "Automatisation",
      readTime: "10 min",
      date: "12 Déc 2024",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600"
    },
    {
      id: 3,
      slug: "google-my-business-optimisation",
      title: "Google My Business : 10 astuces pour booster votre fiche",
      excerpt: "Optimisez votre fiche Google pour apparaître dans le pack local et générer plus d'appels et de visites.",
      category: "SEO",
      readTime: "6 min",
      date: "8 Déc 2024",
      image: "https://images.unsplash.com/photo-1553484771-047a44eee27b?w=600"
    },
    {
      id: 4,
      slug: "digitaliser-commerce-par-ou-commencer",
      title: "Digitaliser son commerce : par où commencer ?",
      excerpt: "Les étapes clés pour transformer votre activité traditionnelle en commerce connecté sans se ruiner.",
      category: "Digital",
      readTime: "7 min",
      date: "5 Déc 2024",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600"
    },
    {
      id: 5,
      slug: "reduire-no-show-restaurant",
      title: "Comment réduire les no-shows de 80% dans votre restaurant",
      excerpt: "Stratégies et outils pour minimiser les réservations non honorées et optimiser votre taux de remplissage.",
      category: "Automatisation",
      readTime: "5 min",
      date: "1 Déc 2024",
      image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600"
    },
    {
      id: 6,
      slug: "avis-clients-reputation-en-ligne",
      title: "Avis clients : transformez vos clients en ambassadeurs",
      excerpt: "Comment collecter, gérer et exploiter les avis clients pour améliorer votre réputation en ligne.",
      category: "Marketing",
      readTime: "6 min",
      date: "28 Nov 2024",
      image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600"
    }
  ];

  const categories = ["Tous", "SEO", "Automatisation", "Digital", "Marketing"];
  const [activeCategory, setActiveCategory] = React.useState("Tous");

  const filteredArticles = activeCategory === "Tous" 
    ? articles 
    : articles.filter(a => a.category === activeCategory);

  return (
    <div className="blog-page">
      <Helmet>
        <title>Blog | Conseils SEO & Digitalisation Commerce | E-Shops SEO</title>
        <meta name="description" content="Conseils SEO, automatisation et digitalisation pour les commerces de proximité. Guides pratiques pour développer votre activité en ligne." />
      </Helmet>

      <section className="blog-hero">
        <div className="container">
          <h1>Blog E-Shops SEO</h1>
          <p className="hero-subtitle">
            Conseils, guides et bonnes pratiques pour digitaliser votre commerce 
            et booster votre visibilité en ligne.
          </p>
        </div>
      </section>

      <section className="blog-content">
        <div className="container">
          <div className="blog-categories">
            {categories.map(cat => (
              <button
                key={cat}
                className={`category-btn ${activeCategory === cat ? "active" : ""}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="articles-grid">
            {filteredArticles.map(article => (
              <Link to={`/blog/${article.slug}`} key={article.id} className="article-card">
                <div className="article-image">
                  <img src={article.image} alt={article.title} />
                  <span className="article-category">{article.category}</span>
                </div>
                <div className="article-content">
                  <div className="article-meta">
                    <span>{article.date}</span>
                    <span>{article.readTime} de lecture</span>
                  </div>
                  <h2>{article.title}</h2>
                  <p>{article.excerpt}</p>
                  <span className="read-more">Lire l'article →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-box">
            <h2>Recevez nos conseils</h2>
            <p>Une fois par mois, les meilleures pratiques pour développer votre commerce.</p>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Votre email" />
              <button type="submit">S'inscrire</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
